var _path, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCalendar = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--calendar",
  viewBox: "0 0 25 25",
  width: 18,
  height: 18,
  ref: svgRef
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.2 2.5V1h-1.5v1.5H6.4V1H4.9v1.5H.3v18.4c0 1.7 1.4 3.1 3.1 3.1h18.4c1.7 0 3.1-1.4 3.1-3.1V2.5h-4.7zM4.9 4.1v1.5h1.5V4.1h12.3v1.5h1.5V4.1h3.1v3.1H1.8V4.1h3.1zm16.8 18.4H3.3c-.8 0-1.5-.7-1.5-1.5V8.7h21.5V21c0 .8-.7 1.5-1.6 1.5z"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 4.9,
  y: 11.7,
  width: 3.1,
  height: 3.1
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  x: 17.1,
  y: 11.7,
  width: 3.1,
  height: 3.1
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  x: 4.9,
  y: 16.3,
  width: 3.1,
  height: 3.1
})), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
  x: 11,
  y: 16.3,
  width: 3.1,
  height: 3.1
})), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
  x: 17.1,
  y: 16.3,
  width: 3.1,
  height: 3.1
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCalendar, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconCalendar.202f8a27.svg";
export { ForwardRef as ReactComponent };